import React from "react";
import PropTypes from "prop-types";
import DataGrid, { DataGridItem } from "components/data-grid";
import RecordingClipsPaginatedTable from "../../../components/common/recording-clips-table/table";

const ClipsData = ({ clipPage, event }) => {

    return (
      <DataGrid>
        <DataGridItem big>
          <RecordingClipsPaginatedTable page={clipPage} pageName={"clipPage"} variables={{ eventId: event.id, eventTitle: event.title }} />
        </DataGridItem>
      </DataGrid>
    );
};

ClipsData.propTypes = {
  /**
   * Page of table
   **/
  page: PropTypes.number,
  /**
   * Data to represent
   **/
  event: PropTypes.object,
};

export default ClipsData;
